var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page",attrs:{"id":"app"}},[(_vm.isSpeedPage)?_c('speed'):[_c('header-nav'),_c('desktop')]],2)
}
var staticRenderFns = []

export { render, staticRenderFns }